export default {
  /****** CANDIDATES ******/
  emailAlreadyBeenTaken: 'An account with this email already exists.',
  /****** END CANDIDATES ******/
  /****** JOBS ******/
  notValidDistance: 'Entered value is not a valid distance',
  setJobStatusError: 'Unable to set job status',
  updateJobAdSuccess: 'Job updated',
  updateJobAdError: 'Job update failed',
  /****** END JOBS ******/

  /****** EMPLOYER ******/
  updateEmployerSuccess: 'Saved',
  updateEmployerError: 'Employer update failed',
  employerNoRecords: 'No records found',
  /****** END EMPLOYER ******/

  /****** COMMENTS ******/
  commentAddedSuccess: 'Comment Added',
  commentAddedError: 'Unable to add comment',
  commentUpdatedSuccess: 'Comment Added',
  commentUpdatedError: 'Unable to update comment',
  commentDeletedSuccess: 'Comment deleted',
  commentDeletedError: 'Unable to delete comment',
  emptyComment: 'Enter your comment first and then hit "Add Comment" button',
  /****** END COMMENTS ******/

  /****** LOGS ******/
  noLogs: `Sorry, we couldn't find any results`,
  /****** END LOGS ******/

  /****** CUSTOM ERRORS ******/
  wrongEmailOrPassword: 'Check your email address and password. Try again.',
  urlNotFound: 'URL Not Found',
  tooManyRequests: 'Too Many Requests.',
  internalServerError: 'There was an error communicating with the server.',
  expiredSession: 'Your session is expired!',
  /****** ENDCUSTOM ERRORS ******/

  /****** COMPONENTS MESSAGES ******/
  dropdownCheckboxMessage: 'No registered jobs',
  dropdownCheckboxMessageJobs: 'There is no jobs for selected employer',
  /****** END COMPONENTS MESSAGES ******/

  /****** GENERIC MESSAGES ******/
  saved: 'Saved',
  validationErrorCityAndCountry: 'Please enter City and Country before editing other information',
  somethingWentWrong: 'Something went wrong',
  /****** END GENERIC MESSAGES ******/
  canSeeError: 'You are not authorized to view this content.',
  managerNoOPtionsMessage: 'No registered jobs',
};
